<template>
  <div>
    <div class="flex flex-wrap -mx-2">
      <div class="w-full md:w-1/2 lg:w-1/3 px-2">
        <h3 class="mb-3 text-lg font-bold">Included Properties</h3>

        <!-- FOR SALE -->
        <div class="mb-3">
          <input type="checkbox" id="include_sales" v-model="form.include_sales">
          <label for="include_sales">Properties For Sale</label>
          <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('include_sales')" v-text="errorBag.get('include_sales')"></small>
        </div>

        <!-- TO LET -->
        <div class="mb-3">
          <input type="checkbox" id="include_lettings" v-model="form.include_lettings">
          <label for="include_lettings">Properties To Let</label>
          <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('include_lettings')" v-text="errorBag.get('include_lettings')"></small>
        </div>

        <!-- SOLD PROPERTIES -->
        <div class="mb-3" v-if="form.include_sales">
          <input type="checkbox" id="include_sold" v-model="form.include_sold">
          <label for="include_sold">SSTC Properties</label>
          <span class="tooltip-container float-right relative">
            <i class="fas fa-info-circle"></i>
            <div class="tooltip-msg bg-white p-3 border shadow absolute pin-t pin-r pointer-events-none w-48 text-xs z-10">
              When enabled, this will include published sales listings not marked as 'Available'. Such as SSTC, Under Offer and Sold. Otherwise only 'available' listings will be included.
            </div>
          </span>

          <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('include_sold')" v-text="errorBag.get('include_sold')"></small>
        </div>

        <!-- LET PROPERTIES -->
        <div class="mb-3" v-if="form.include_lettings">
          <input type="checkbox" id="include_let" v-model="form.include_let">
          <label for="include_let">Let Agreed Properties</label>
          <span class="tooltip-container float-right relative">
            <i class="fas fa-info-circle"></i>
            <div class="tooltip-msg bg-white p-3 border shadow absolute pin-t pin-r pointer-events-none w-48 text-xs z-10">
              When enabled, this will include published rental listings not marked as 'Available'. Such as Let Agreed, Under Offer and Let. Otherwise only 'available' listings will be included.
            </div>
          </span>

          <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('include_let')" v-text="errorBag.get('include_let')"></small>
        </div>

        <!-- FREQUENCY -->
        <div class="mb-6 mt-6">
          <label for="frequency_id">Frequency:</label>
          <select id="frequency_id" v-model="form.frequency_id" class="block w-full bg-grey-lighter border hover:border-grey focus:border-grey-dark p-2 mt-2 h-10 text-sm" :class="{ 'border-red-dark hover:border-red-dark focus:border-red-dark': errorBag.get('frequency_id') }">
            <option :value="0">Weekly</option>
            <option :value="1">Fortnightly</option>
            <option :value="2">Monthly</option>
            <option :value="3">Bimonthly</option>
          </select>
          <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('frequency_id')" v-text="errorBag.get('frequency_id')"></small>
        </div>

        <!-- PROPERTY PAGES DISPLAYED BY -->
        <div class="mb-6">
          <label for="property_group_by_id">Property Pages Displayed By:</label>
          <select id="property_group_by_id" v-model="form.property_group_by_id" class="block w-full bg-grey-lighter border hover:border-grey focus:border-grey-dark p-2 mt-2 h-10 text-sm" :class="{ 'border-red-dark hover:border-red-dark focus:border-red-dark': errorBag.get('property_group_by_id') }">
            <option :value="0">Office</option>
            <option :value="1">Location</option>
            <option :value="2">Office and Location</option>
          </select>
          <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('property_group_by_id')" v-text="errorBag.get('property_group_by_id')"></small>
        </div>

        <!-- DISPLAY PROPERTIES SINCE -->
        <div class="mb-6">
          <label for="property_since_id">Display Properties Listed Since:</label>
          <select id="property_since_id" v-model="form.property_since_id" class="block w-full bg-grey-lighter border hover:border-grey focus:border-grey-dark p-2 mt-2 h-10 text-sm" :class="{ 'border-red-dark hover:border-red-dark focus:border-red-dark': errorBag.get('property_since_id') }">
            <option :value="0">All Time</option>
            <option :value="1">Last Edition</option>
            <option :value="2">Last Fortnight</option>
            <option :value="3">Last Month</option>
          </select>
          <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('property_since_id')" v-text="errorBag.get('property_since_id')"></small>
        </div>

        <!-- PROPERTY ORDER -->
        <div class="mb-6">
          <label for="property_order_id">Order Properties on each page by:</label>
          <select id="property_order_id" v-model="form.property_order_id" class="block w-full bg-grey-lighter border hover:border-grey focus:border-grey-dark p-2 mt-2 h-10 text-sm" :class="{ 'border-red-dark hover:border-red-dark focus:border-red-dark': errorBag.get('property_order_id') }">
            <option :value="0">Price Descending</option>
            <option :value="1">Price Ascending</option>
            <option :value="2">Recently Added</option>
          </select>
          <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('property_order_id')" v-text="errorBag.get('property_order_id')"></small>
        </div>
      </div>

      <div class="w-full md:w-1/2 lg:w-2/3 px-2">
        <h3 class="mb-3 text-lg font-bold">Offices &amp; Locations</h3>
        <div class="bg-grey-lighter border rounded p-3 mb-6">
          <div class="flex -mx-2">
            <div class="w-full md:w-1/2 px-2">
              <div>
                <h4 class="mb-3">Included Offices</h4>

                <div class="border rounded flex-1 flex items-stretch overflow-hidden mb-2 text-sm" :class="{'bg-white': form.offices_list.includes(office.id), 'bg-blue-lighter border-blue': form.property_group_by_id === 2 && office.id === selectedOffice.id}" v-for="office in offices" :key="office.id">
                  <div class="p-2 flex-grow min-w-0" :title="`Toggle inclusion of ${office.address_town} office`">
                    <input type="checkbox" :id="`office.${office.id}`" v-model="form.offices_list" :value="office.id" :disabled="form.property_group_by_id === 2 && office.locations.length === 0" @change="togglePage(office.id, null)">
                    <label :for="`office.${office.id}`" class="w-full block truncate">
                      {{ office.name }} ({{ office.address_town }})
                      <small class="block text-grey-dark ml-8 truncate">{{ office.network.name }}<span v-if="office.is_hidden"> - Hidden Office</span></small>
                    </label>
                  </div>
                  <button v-if="form.property_group_by_id === 2" :title="`View ${office.address_town} locations`" class="px-3 flex items-center justify-center" @click="selectedOffice = office" :class="office.id === selectedOffice.id ? 'text-white bg-blue' : 'bg-grey-lighter hover:bg-grey-light text-grey hover:text-grey-darker border-l'">
                    <i class="fas fa-arrow-right fa-fw"></i>
                  </button>
                </div>
              </div>
            </div>

            <div class="w-full md:w-1/2 px-2" v-if="[1, 2].includes(form.property_group_by_id)">
              <div>
                <h4 class="mb-3">{{ selectedOffice ? `Included ${selectedOffice.address_town} Locations` : 'Included Locations' }}</h4>
                <p class="text-xs mb-6"><i class="fas fa-arrows-alt"></i> Drag and drop to group and reorder locations.</p>

                <p class="text-sm italic" v-if="(selectedOffice ? selectedOffice.locations : allLocations).length === 0">
                  {{ selectedOffice ? 'This office has' : 'The selected offices have' }} no listings.
                </p>
                <div v-else v-for="(locationGroup, i) in groupedLocations" :key="`item${i}`" class="border rounded flex flex-col overflow-hidden text-sm mb-2">
                  <div class="p-2 relative" :class="{'border-t': j > 0, 'bg-white': pageForModule(selectedOffice ? selectedOffice.id : null, location) !== null}" :title="`Toggle inclusion of ${location}`" v-for="(location, j) in locationGroup" :key="location" :draggable="pageForModule(selectedOffice ? selectedOffice.id : null, location) !== null" @dragstart="locationStartMove($event, location)" @dragend="movingLocation = null;" @drop.stop="locationEndMove($event, location, 'merge')" @dragenter.prevent @dragover.prevent>
                    <i class="fas fa-link absolute pin-t pin-r -mt-2 mr-2" v-if="j > 0"></i>
                    <input type="checkbox" :id="`location.${i}.${j}`" :checked="pageForModule(selectedOffice ? selectedOffice.id : null, location) !== null" @change="togglePage(selectedOffice ? selectedOffice.id : null, location)">
                    <label :for="`location.${i}.${j}`" class="w-full truncate">{{ location }}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="flex flex-wrap -mx-2">
          <div class="w-full lg:w-1/2 px-2">
            <h3 class="mb-3 text-base font-bold">Price Range</h3>
            <div class="bg-grey-lighter border rounded p-3 mb-6">
              <h4 class="mb-3 text-sm font-bold">Include Properties Within Price Range</h4>

              <!-- SALE PRICE RANGE -->
              <div class="mb-6">
                <label for="min_price">Minimum Price:</label>
                <div class="flex items-stretch mt-2 text-sm">
                  <div class="bg-white border border-r-0 p-3 font-bold">£</div>
                  <input type="text" pattern="\d*" id="min_price" v-model.number="form.min_price" placeholder="No minimum price" class="block w-full bg-white border hover:border-grey focus:border-grey-dark p-2 text-sm" :class="{ 'border-red-dark hover:border-red-dark focus:border-red-dark': errorBag.get('min_price') }">
                </div>
                <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('min_price')" v-text="errorBag.get('min_price')"></small>
              </div>

              <div class="mb-6">
                <label for="max_price">Maximum Price:</label>
                <div class="flex items-stretch mt-2 text-sm">
                  <div class="bg-white border border-r-0 p-3 font-bold">£</div>
                  <input type="text" pattern="\d*" id="max_price" v-model.number="form.max_price" placeholder="No maximum price" class="block w-full bg-white border hover:border-grey focus:border-grey-dark p-2 text-sm" :class="{ 'border-red-dark hover:border-red-dark focus:border-red-dark': errorBag.get('max_price') }">
                </div>
                <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('max_price')" v-text="errorBag.get('max_price')"></small>
              </div>

              <!-- RENT PRICE RANGE -->
              <div class="mb-6 border-t pt-6">
                <label for="min_rent">Minimum Rent:</label>
                <div class="flex items-stretch mt-2 text-sm">
                  <div class="bg-white border border-r-0 p-3 font-bold">£</div>
                  <input type="text" pattern="\d*" id="min_rent" v-model.number="form.min_rent" placeholder="No minimum rent" class="block w-full bg-white border hover:border-grey focus:border-grey-dark p-2 text-sm" :class="{ 'border-red-dark hover:border-red-dark focus:border-red-dark': errorBag.get('min_rent') }">
                  <div class="bg-white border border-l-0 p-3 font-bold">pcm</div>
                </div>
                <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('min_rent')" v-text="errorBag.get('min_rent')"></small>
              </div>

              <div class="mb-6">
                <label for="max_rent">Maximum Rent:</label>
                <div class="flex items-stretch mt-2 text-sm">
                  <div class="bg-white border border-r-0 p-3 font-bold">£</div>
                  <input type="text" pattern="\d*" id="max_rent" v-model.number="form.max_rent" placeholder="No maximum rent" class="block w-full bg-white border hover:border-grey focus:border-grey-dark p-2 text-sm" :class="{ 'border-red-dark hover:border-red-dark focus:border-red-dark': errorBag.get('max_rent') }">
                  <div class="bg-white border border-l-0 p-3 font-bold">pcm</div>
                </div>
                <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('max_rent')" v-text="errorBag.get('max_rent')"></small>
              </div>
            </div>
          </div>

          <div class="w-full lg:w-1/2 px-2">
            <h3 class="mb-3 text-base font-bold">Property Types</h3>
            <div class="bg-grey-lighter border rounded p-3 mb-6">
              <h4 class="mb-3 text-sm font-bold">Included Properties</h4>

              <!-- PROPERTY TYPES -->
              <div class="mb-3" v-for="propertyTypeGroup in propertyTypeGroups" :key="propertyTypeGroup.id">
                <input type="checkbox" :id="`propertyType.${propertyTypeGroup.id}`" v-model="form.property_type_group_ids" :value="propertyTypeGroup.id">
                <label :for="`propertyType.${propertyTypeGroup.id}`">{{ propertyTypeGroup.name }}</label>
              </div>
              <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('property_type_group_ids')" v-text="errorBag.get('property_type_group_ids')"></small>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import randomstring from 'randomstring'
import { filter, find, flatten, difference } from 'lodash'
import { v2Api } from '@/http'

export default {
  props: ['errorBag', 'value', 'offices', 'pageGroups'],
  data () {
    return {
      form: this.value,
      modules: [],
      propertyTypeGroups: [
        { id: 0, name: 'Not Specified' },
        { id: 1, name: 'House' },
        { id: 2, name: 'Flat / Apartment' },
        { id: 3, name: 'Bungalow' },
        { id: 4, name: 'Character Property' },
        { id: 5, name: 'Commercial Property' },
        { id: 6, name: 'Garage / Parking' },
        { id: 7, name: 'Guest House / Hotel' },
        { id: 8, name: 'House / Flat Share' },
        { id: 9, name: 'Land' },
        { id: 10, name: 'Mobile / Park Home' },
        { id: 11, name: 'Retirement Property' }
      ],
      selectedOffice: null,
      movingLocation: null
    }
  },
  created () {
    this.selectedOffice = this.form.property_group_by_id === 2 && this.offices ? this.offices[0] : null
    this.getModules()

    document.body.addEventListener('drop', this.globalDrop)
    document.body.addEventListener('dragenter', this.prevent)
    document.body.addEventListener('dragover', this.prevent)
  },
  beforeDestroy () {
    document.body.removeEventListener('drop', this.globalDrop)
    document.body.removeEventListener('dragenter', this.prevent)
    document.body.removeEventListener('dragover', this.prevent)
  },
  computed: {
    propertyPageGroupId () {
      return Array.isArray(this.pageGroups) ? this.pageGroups.find((group) => group.type_id === 1).id : null
    },
    allLocations () {
      let output = []

      for (let i = 0; i < this.offices.length; i++) {
        if (!this.form.offices_list.includes(this.offices[i].id)) {
          continue
        }

        for (let j = 0; j < this.offices[i].locations.length; j++) {
          if (output.indexOf(this.offices[i].locations[j]) >= 0) {
            continue
          }

          output.push(this.offices[i].locations[j])
        }
      }

      output.sort()

      return output
    },
    groupedLocations () {
      let output = []
      const officeId = this.selectedOffice ? this.selectedOffice.id : null
      const relevantPages = filter(this.form.pages, (page) => page.content_type === 'App\\Models\\EzinePage' && page.content.ezine_page_group_id === this.propertyPageGroupId && find(page.content.modules, (m) => m.module.component === 'properties-module' && m.office_id === officeId && m.data.location && m.data.rental === this.enabledDepartments[0]))

      for (let i = 0; i < relevantPages.length; i++) {
        output.push(filter(relevantPages[i].content.modules, (m) => m.module.component === 'properties-module' && m.office_id === officeId && m.data.location).map((m) => m.data.location))
      }

      const usedLocations = flatten(output)
      const allLocations = this.selectedOffice ? this.selectedOffice.locations : this.allLocations
      const otherLocations = difference(allLocations, usedLocations)
      for (let i = 0; i < otherLocations.length; i++) {
        output.push([otherLocations[i]])
      }

      return output
    },
    enabledDepartments () {
      let output = []

      if (this.form.include_sales) {
        output.push(false)
      }
      if (this.form.include_lettings) {
        output.push(true)
      }

      return output
    },
    propertyModule () {
      const mod = this.modules.find((m) => m.component === 'properties-module')

      return mod ? {
        id: mod.id,
        locked: mod.locked,
        component: mod.component
      } : null
    }
  },
  methods: {
    prevent (e) {
      e.preventDefault()
    },
    getModules () {
      v2Api.get(`/ezine-modules`).then((response) => {
        this.modules = response.data
      })
    },
    globalDrop (event) {
      if (this.movingLocation) {
        this.locationEndMove(event, null, 'new')
      }
    },
    pageForModule (officeId, location, locationCheck = true) {
      if (!this.offices || !this.form || !this.pageGroups) {
        return false
      }

      return this.form.pages.find((page) => page.content.ezine_page_group_id === this.propertyPageGroupId && page.content.modules && page.content.modules.find((m) => m.module.component === 'properties-module' && m.office_id === officeId && (!locationCheck || m.data.location === location))) || null
    },
    togglePage (officeId, location) {
      if (this.form.property_group_by_id === 1 && officeId && !location) {
        let output = []
        for (let p = 0; p < this.form.pages.length; p++) {
          if (this.form.pages[p].content.ezine_page_group_id !== this.propertyPageGroupId) {
            output.push(this.form.pages[p])
            continue
          }

          this.form.pages[p].content.modules = this.form.pages[p].content.modules.filter((m) => m.module.component !== 'properties-module' || this.allLocations.includes(m.data.location))
          if (this.form.pages[p].content.modules.length > 0) {
            output.push(this.form.pages[p])
          }
        }
        this.form.pages = output
        return
      }

      const isOffice = location === null
      let didDelete = false
      let page = null

      // eslint-disable-next-line
      while (page = this.pageForModule(officeId, location, !isOffice)) {
        let index = null
        // eslint-disable-next-line
        while ((index = page.content.modules.indexOf(page.content.modules.find((m) => m.module.component === 'properties-module' && m.office_id === officeId && (isOffice || m.data.location === location)))) >= 0) {
          page.content.modules.splice(index, 1)
          if (page.content.modules.length === 0) {
            this.form.pages.splice(this.form.pages.indexOf(page), 1)
          }
        }
        didDelete = true
      }
      if (didDelete) {
        return
      }

      let office = this.offices.find((o) => o.id === officeId) || null
      let locations = [1, 2].includes(this.form.property_group_by_id) ? (location ? [location] : office.locations) : [null]

      for (let i = 0; i < locations.length; i++) {
        for (let r = 0; r < this.enabledDepartments.length; r++) {
          this.addPropertyPage(office, locations[i], this.enabledDepartments[r])
        }
      }
    },
    addPropertyPage (office, location, rental) {
      this.form.pages.push({
        ref: randomstring.generate(),
        content_type: 'App\\Models\\EzinePage',
        content: {
          ezine_page_group_id: this.propertyPageGroupId,
          name: office ? `Property - ${office.address_town} Office (${rental ? 'Lettings' : 'Sales'})` : `Property Page (${rental ? 'Lettings' : 'Sales'})`,
          modules: [
            {
              ezine_module_id: this.propertyModule.id,
              module: this.propertyModule,
              office_id: office ? office.id : null,
              data: {
                location: location,
                rental: rental,
                background_colour: 'bg-white'
              }
            }
          ]
        }
      })
    },
    resetPropertyPages () {
      this.selectedOffice = this.form.property_group_by_id === 2 && this.offices ? this.offices[0] : null

      // Remove all property pages first
      this.form.pages = filter(this.form.pages, (page) => page.content_type === 'App\\Models\\EzinePageGroup' || (page.content_type === 'App\\Models\\EzinePage' && page.content.ezine_page_group_id !== this.propertyPageGroupId))

      // Add property pages
      if (this.form.property_group_by_id === 1) {
        for (let i = 0; i < this.allLocations.length; i++) {
          for (let r = 0; r < this.enabledDepartments.length; r++) {
            this.addPropertyPage(null, this.allLocations[i], this.enabledDepartments[r])
          }
        }
        return
      }

      for (let i = 0; i < this.offices.length; i++) {
        if (!this.form.offices_list.includes(this.offices[i].id)) {
          continue
        }

        if ([0, 3, 4].includes(this.form.property_group_by_id)) {
          for (let r = 0; r < this.enabledDepartments.length; r++) {
            this.addPropertyPage(this.offices[i], null, this.enabledDepartments[r])
          }
        } else if (this.form.property_group_by_id === 2) {
          for (let j = 0; j < this.offices[i].locations.length; j++) {
            for (let r = 0; r < this.enabledDepartments.length; r++) {
              this.addPropertyPage(this.offices[i], this.offices[i].locations[j], this.enabledDepartments[r])
            }
          }
        }
      }
    },
    locationStartMove (event, location) {
      event.dataTransfer.setData('text/plain', 'location')
      this.movingLocation = location
    },
    locationEndMove (event, target, action) {
      if (!this.movingLocation) {
        return
      }
      const entity = event.dataTransfer.getData('text/plain')
      if (entity !== 'location') {
        this.movingLocation = null
        return
      }

      const officeId = this.selectedOffice ? this.selectedOffice.id : null
      for (let d = 0; d < this.enabledDepartments.length; d++) {
        const rental = this.enabledDepartments[d]

        if (action === 'merge') {
          const currentPage = find(this.form.pages, (page) => page.content_type === 'App\\Models\\EzinePage' && page.content.ezine_page_group_id === this.propertyPageGroupId && find(page.content.modules, (m) => m.module.component === 'properties-module' && m.office_id === officeId && m.data.rental === rental && m.data.location === this.movingLocation))
          const targetPage = find(this.form.pages, (page) => page.content_type === 'App\\Models\\EzinePage' && page.content.ezine_page_group_id === this.propertyPageGroupId && find(page.content.modules, (m) => m.module.component === 'properties-module' && m.office_id === officeId && m.data.rental === rental && m.data.location === target))

          if (!currentPage || !targetPage) {
            this.movingLocation = null
            return
          }

          const currentModule = find(currentPage.content.modules, (m) => m.module.component === 'properties-module' && m.office_id === officeId && m.data.rental === rental && m.data.location === this.movingLocation)
          const targetModule = find(targetPage.content.modules, (m) => m.module.component === 'properties-module' && m.office_id === officeId && m.data.rental === rental && m.data.location === target)

          if (currentModule === targetModule) {
            this.movingLocation = null
            return
          }

          const currentIndex = currentPage.content.modules.indexOf(currentModule)
          const newIndex = targetPage.content.modules.indexOf(targetModule)

          currentPage.content.modules.splice(currentIndex, 1)
          targetPage.content.modules.splice(newIndex, 0, currentModule)

          if (currentPage.content.modules.length === 0) {
            this.form.pages.splice(this.form.pages.indexOf(currentPage), 1)
          }
        }

        if (action === 'new') {
          const currentPage = find(this.form.pages, (page) => page.content_type === 'App\\Models\\EzinePage' && page.content.ezine_page_group_id === this.propertyPageGroupId && find(page.content.modules, (m) => m.module.component === 'properties-module' && m.office_id === officeId && m.data.rental === rental && m.data.location === this.movingLocation))
          if (!currentPage) {
            this.movingLocation = null
            return
          }

          const currentModule = find(currentPage.content.modules, (m) => m.module.component === 'properties-module' && m.office_id === officeId && m.data.rental === rental && m.data.location === this.movingLocation)
          const office = currentModule.office_id ? (find(this.offices, (office) => office.id === currentModule.office_id) || null) : null

          currentPage.content.modules.splice(currentPage.content.modules.indexOf(currentModule), 1)
          this.addPropertyPage(office, this.movingLocation, currentModule.data.rental)

          if (currentPage.content.modules.length === 0) {
            this.form.pages.splice(this.form.pages.indexOf(currentPage), 1)
          }
        }
      }

      this.movingLocation = null
    }
  },
  watch: {
    form: {
      handler () {
        this.$emit('input', this.form)
      },
      deep: true
    },
    'form.min_price' (value) {
      if (value === '') {
        this.form.min_price = null
      }
    },
    'form.max_price' (value) {
      if (value === '') {
        this.form.max_price = null
      }
    },
    'form.min_rent' (value) {
      if (value === '') {
        this.form.min_rent = null
      }
    },
    'form.max_rent' (value) {
      if (value === '') {
        this.form.max_rent = null
      }
    },
    'form.include_sales' (on) {
      if (!on && !this.form.include_lettings) {
        this.form.include_lettings = true
      }

      this.resetPropertyPages()
    },
    'form.include_lettings' (on) {
      if (!on && !this.form.include_sales) {
        this.form.include_sales = true
      }

      this.resetPropertyPages()
    },
    'form.property_group_by_id' () {
      this.resetPropertyPages()
    }
  }
}
</script>
